<template>
    <div class="component cta-brand-design section" data-shape-id="ctaBrandDesign">
        <div class="wrapper wrapper-medium">
            <div class="section-visual">
                <img src="../../assets/svg/cta/cta.svg" alt="The Telekom Brand and Design Portal" />
            </div>
            <div class="section-copy">
                <div class="overline">Brand & Design</div>
                <h2 class="major-heading">Get<br />started</h2>
                <p>
                    We provide everything you need to create amazing experiences on our Brand & Design platform.
                </p>
                <div class="container-cta">
                    <p class="copy">
                        Explore all elements <br />and resources on:<br />
                        <span class="fw-bold">
                            <a href="http://www.brand-design.telekom.com" target="_blank">
                                www.brand-design.telekom.com
                            </a>
                        </span>
                    </p>
                    <!--
                    <div class="container-button">
                        <link-icon
                            href="https://www.brand-design.telekom.com"
                            target="_blank"
                            icon="arrowRight"
                            srText="Go to page xyz"
                        />
                    </div>
                    -->
                </div>
            </div>
        </div>
        <particles :particles="particles" />
    </div>
</template>

<script>
    //import LinkIcon from '../patterns/buttons/LinkIcon.vue';
    import Particles from './../Particles';

    export default {
        name: 'CtaBrandDesign',
        components: {
            /*LinkIcon,*/
            Particles,
        },
        data() {
            return {
                particles: [
                    {
                        shape: 'parallelogram',
                        color: 'wild-blue-yonder',
                        size: 'l',
                        top: 30,
                        left: 2,
                    },
                    {
                        shape: 'circle',
                        color: 'magenta',
                        top: 70,
                        left: 5,
                    },
                    {
                        shape: 'circle',
                        color: 'geyser',
                        size: 'l',
                        top: 60,
                        right: -2,
                    },
                    {
                        shape: 'parallelogram',
                        color: 'wild-blue-yonder',
                        size: 's',
                        top: 68,
                        right: 1,
                    },
                ],
            };
        },
    };
</script>

<style scoped lang="scss">
    .cta-brand-design {
        .wrapper {
            @include flex($align-items: center);

            @media (max-width: breakpoint('medium')) {
                @include flex($flex-direction: column-reverse);
            }
        }

        .section-visual,
        .section-copy {
            width: 50%;

            @media (max-width: breakpoint('medium')) {
                width: 100%;
            }
        }

        .section-visual {
            @media (max-width: breakpoint('medium')) {
                margin-top: spacing(10);
            }

            @media (max-width: breakpoint('small')) {
                display: none;
            }

            img {
                @include reset-img();
                width: 65%;

                @media (max-width: breakpoint('medium')) {
                    margin: 0 auto;
                    height: 15vh;
                    width: auto;
                }
            }
        }

        .container-cta {
            position: relative;
            margin-top: spacing(5);
            display: inline-block;

            .copy {
                padding-right: 75px;
                @include border-box();

                @media (min-width: breakpoint('small') + 1) {
                    br:first-of-type {
                        display: none;
                    }
                }

                @media (max-width: breakpoint('small')) {
                    padding-right: 0;
                }
            }

            .container-button {
                position: absolute;
                right: -#{spacing(5)};
                top: 50%;
                width: 60px;
                height: 60px;
                transform: translateY(-50%);

                @media (max-width: breakpoint('small')) {
                    position: initial;
                    transform: none;
                    margin: spacing(3) auto 0 auto;
                }
            }
        }

        p {
            line-height: 1.3em;
        }

        @media (max-width: breakpoint('medium')) {
            text-align: center;
        }
    }
</style>
